/**
 * Configuration de base de l'API
 * Toutes les requêtes passent par cette instance
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Récupère le token d'authentification
 */
const getAuthToken = () => localStorage.getItem('authToken');

/**
 * Headers par défaut pour les requêtes
 */
const getHeaders = (includeAuth = true) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (includeAuth) {
    const token = getAuthToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  return headers;
};

/**
 * Gestion des erreurs de réponse
 */
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Erreur réseau' }));

    // Token expiré ou invalide
    if (response.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/';
    }

    throw new Error(error.message || `Erreur ${response.status}`);
  }

  return response.json();
};

/**
 * Méthodes HTTP de base
 */
export const api = {
  get: async (endpoint, includeAuth = true) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'GET',
      headers: getHeaders(includeAuth),
    });
    return handleResponse(response);
  },

  post: async (endpoint, data, includeAuth = true) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: getHeaders(includeAuth),
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },

  put: async (endpoint, data, includeAuth = true) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'PUT',
      headers: getHeaders(includeAuth),
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },

  delete: async (endpoint, includeAuth = true) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'DELETE',
      headers: getHeaders(includeAuth),
    });
    return handleResponse(response);
  },
};

export default api;
